import debounce from 'lodash.debounce';
import Log from '@deephaven/log';
import { useEffect, useMemo } from 'react';
import useTableUtils from "./useTableUtils.js";
var log = Log.module('useDebouncedViewportSearch');
export var DEBOUNCE_VIEWPORT_SEARCH_MS = 200;

/**
 * React hook that returns a debounced search callback for filtering a table
 * viewport.
 * @param viewportData Table viewport to filter
 * @param columnName Column name to filter by
 * @param debounceMs Millisecond value to debounce
 * @returns A debounced search function
 */
export function useDebouncedViewportSearch(viewportData, columnName) {
  var debounceMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEBOUNCE_VIEWPORT_SEARCH_MS;
  var tableUtils = useTableUtils();
  var table = viewportData.table,
    applyFiltersAndRefresh = viewportData.applyFiltersAndRefresh;
  var debouncedSearch = useMemo(() => debounce(searchText => {
    log.debug("Applying debounced searchText '".concat(searchText, "'"));
    if (table == null) {
      return;
    }
    var searchTextTrimmed = searchText.trim();
    if (searchTextTrimmed === '') {
      applyFiltersAndRefresh([]);
      return;
    }
    var column = table.findColumn(columnName);
    var value = tableUtils.makeFilterValue(column.type, searchTextTrimmed);
    var filter = [column.filter().contains(value)];
    applyFiltersAndRefresh(filter);
  }, debounceMs), [applyFiltersAndRefresh, columnName, debounceMs, table, tableUtils]);
  useEffect(() => () => {
    log.debug('Cancelling debounced search function');
    debouncedSearch.cancel();
  }, [debouncedSearch]);
  return debouncedSearch;
}
export default useDebouncedViewportSearch;
//# sourceMappingURL=useDebouncedViewportSearch.js.map